import { fromJS, Map } from 'immutable';
import { apiFetchThunk } from 'src/common/ducks/fetch';
import { fetchCatch } from 'src/core/sentry';
import { Occasion } from 'src/types/trips/Trips';

// Actions
const SET_OCCASIONS = 'occasions/occasions/SET_OCCASIONS';

// Reducer
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function occasionsReducer(state = Map(), action) {
  switch (action.type) {
    case SET_OCCASIONS:
      return action.occasions;
    default:
      return state;
  }
}

// Basic action creators
export const setOccasions = (occasions: Occasion[]) => ({ type: SET_OCCASIONS, occasions });

export const getOccasionsCall = () => async dispatch => {
  const response = await dispatch(apiFetchThunk('/trips/occasions/'));
  if (!response.ok) {
    fetchCatch(response);
    throw response;
  }
  const occasions = await response.json().then(fromJS);
  dispatch(setOccasions(occasions));
};
